// @ts-nocheck

import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../redux/services/ReduxAsyncAction';
import { isSavedAdAccount } from '../components/PartnerManager/utils';
import dash_api from '../support/dash_api';
import { ReduxAsyncAction as LegacyReduxAsyncAction } from '../support/utils';
import type { AdPartner, AdwordsAccount } from '../types/adPartnerTypes';
import type { AdPartnerCredentials } from '../types/adPartnerTypes';
import type { LinkIds } from '../types/googleTypes';
import NotificationActions from './NotificationActions';

const GOOGLE_ROUTE = '/v1/google';
const GetAdWordsAccounts = new LegacyReduxAsyncAction('GOOGLE_ADWORDS_GET_ACCOUNTS');
GetAdWordsAccounts.registerRequest((savedAccounts: AdwordsAccount[]) => {
  return dash_api.get(`${GOOGLE_ROUTE}/get-accounts`).then(({ data }) => {
    return {
      accounts: data.map((account) => ({ ...account, checked: isSavedAdAccount(account.account_id, savedAccounts) })),
    };
  });
});
export const GET_GOOGLE_ACCOUNTS = GetAdWordsAccounts.constants;
export const getAdWordsAccounts = GetAdWordsAccounts.request;

/* ------------------------------------------------------
 The following actions are used in the AdPartnerReducer
 instead of the GoogleReducer.
-------------------------------------------------------- */
const SaveAdWordsOnboarding = new ReduxAsyncAction('GOOGLE_ADWORDS_SAVE');
SaveAdWordsOnboarding.registerRequest((toSave) => {
  return dash_api.post(`${GOOGLE_ROUTE}/save`, { ...toSave }).then(({ data }) => {
    data.neverConfigured = false;
    NotificationActions.showNotification(`Google AdWords has been saved and enabled`, 'success');
    return data;
  });
});
export const GOOGLE_ADWORDS_SAVE = SaveAdWordsOnboarding.actionNamespaceConstants;
export const saveAdWordsOnboarding = SaveAdWordsOnboarding.request;

export type SaveAdWordsOnboardingResponseAction = Action<typeof GOOGLE_ADWORDS_SAVE.response> & { data: AdPartner };

const GetAdWordsUserInfo = new ReduxAsyncAction('GOOGLE_ADWORDS_GET_USER_INFO');
GetAdWordsUserInfo.registerRequest(() => {
  return dash_api.get(`${GOOGLE_ROUTE}/get-user-info`).then(({ data }) => {
    return data;
  });
});
export const GET_GOOGLE_USER_INFO = GetAdWordsUserInfo.actionNamespaceConstants;
export const getAdWordsUserInfo = GetAdWordsUserInfo.request;

export type GetAdWordsUserInfoResponseAction = Action<typeof GET_GOOGLE_USER_INFO.response> & { data: AdPartnerCredentials };

const RevokeGoogleAuth = new ReduxAsyncAction('GOOGLE_ADWORDS_REVOKE_AUTH');
RevokeGoogleAuth.registerRequest(() => {
  return dash_api.post(`${GOOGLE_ROUTE}/revoke-auth`).then(({ data }) => data);
});
export const REVOKE_GOOGLE_AUTH = RevokeGoogleAuth.actionNamespaceConstants;

export const revokeGoogleAuth = RevokeGoogleAuth.request;

export type RevokeGoogleAuthResponseAction = Action<typeof REVOKE_GOOGLE_AUTH.response> & { data: AdPartner };

const ValidateGoogleLinkIds = new LegacyReduxAsyncAction('GOOGLE_ADWORDS_VALIDATE_LINK_IDS');
ValidateGoogleLinkIds.registerRequest((linkIdsToValidate: LinkIds, useTuneDevToken?: boolean) => {
  return dash_api
    .post(`/v1/san-onboarding-validation/google`, {
      link_ids: linkIdsToValidate,
      use_tune_dev_token: useTuneDevToken,
    })
    .then(({ data }) => {
      return data;
    });
});
export const VALIDATE_GOOGLE_LINK_IDS = ValidateGoogleLinkIds.constants;
export const validateGoogleLinkIds = ValidateGoogleLinkIds.request;
